import { render, staticRenderFns } from "./Insured.vue?vue&type=template&id=22922f1c&"
import script from "./Insured.vue?vue&type=script&lang=js&"
export * from "./Insured.vue?vue&type=script&lang=js&"
import style0 from "./Insured.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Insured.vue"
export default component.exports